"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    standardsInformationModal: {
        heading: 'Standard Information for {{standardsName}}',
        code: 'Code',
        domain: 'Domain',
        strand: 'Strand',
        cluster: 'Cluster',
        teks: 'Teks',
        description: 'Description',
        emptyData: {
            primaryText: 'No Data Available',
            secondaryText: 'We could not show any data by the moment, please try again later',
        },
        ariaLabel: {
            description: 'Standard Description for {{standardName}}',
            teks: 'Standard Teks for {{standardName}}',
            fetchingInformation: 'Fetching Standards Information',
        },
    },
};
